import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { colors, fonts, useMediaQuery } from "../Styles";
import { NewInput, NewSelect } from "../Components";
import { NewFieldStyles, FieldStyles } from ".";
import { ValueType } from "./valueTypes";

/* eslint-disable */
export enum ActionDisplayEnum {
  select = "select",
  input = "input",
  date = "date",
  costum = "costum"
}
/* eslint-enable */

export interface ActionField {
  id?: number,
  value?: ValueType
}

export interface ActionDisplayType {
  id: number,
  label: string,
  displayType?: ActionDisplayEnum,
  options?: {
    label: string,
    id: number
  }[],
  text?: string
}

export const ActionContent = (props: {filter: ActionField, index?: number, filterParameterTypes?: ActionDisplayType[], handleFilterValueChange: (value: any) => void, costumContent?: JSX.Element, focus_view?: boolean }) => { 
  const {t} = useTranslation()
  const [field, setField] = useState<ActionField>();
  const {filter, filterParameterTypes } = props;
  const filterParameter = filterParameterTypes?.find((filterParameterType) => filterParameterType.id === filter.id)
  // const mobileXs = useMediaQuery(`(max-width: 793px)`) || props.focus_view;

  const [tempInput, setTempInput] = useState("");

  useEffect(() => {
    if (filter.value) {
      setField({ ...filter.value });
    } else {
      setField({ id: -1 });
    }
  }, [filter.value]);

  const handleFieldChange = (value: { id: number }) => {
    setField((prevField) => ({
      ...prevField,
      id: value.id
    }));
    props.handleFilterValueChange([value]);
  };

  // Delete field
  const handleFieldDelete = useCallback(() => {
    setField({ id: -1 });
  }, []);
  
  if (!filterParameter?.displayType) {
    return null
  }
  console.log(filterParameter.options, field?.id);
  switch (filterParameter.displayType) {
    case ActionDisplayEnum.select:
      return (
        <div style={{boxSizing: "border-box"}}>
          {field && field.id !== undefined ?
            <div key={field.id !== undefined ? `${field.id}` : "initial"}>
              <NewSelect
                header={t("to", {defaultValue: "to"})}
                placeholder={t("select", {defaultValue: "select"})}
                options={filterParameter.options || []}
                onChange={(option) => { 
                  if (option) handleFieldChange({ id: Number(option.id) });
                }}
                isClearable={field.id !== -1}
                onClear={() => handleFieldDelete()}
                fieldOverrides={{
                  fieldStyle: props.focus_view ? NewFieldStyles.greyDarkPrimary : NewFieldStyles.blueDarkSecondary,
                  fieldWidth: props.focus_view ? "100%" : undefined,
                  focus_view: props.focus_view
                }}
                valueOverrides={{
                  defaultValue: filterParameter.options?.find((option) => (option.id === field?.id) || ((Number.isNaN(option.id) && Number.isNaN(field?.id)))) || undefined
                }}
              />
            </div>
          : <></>}
        </div>
      )
      case ActionDisplayEnum.input:
        return (
          <div style={{ boxSizing: "border-box" }}>
            {field !== undefined ? (
              <div key={field.id !== undefined ? `${field.id}` : "initial"}>
                <NewInput
                  header={t("to", {defaultValue: "to"})}
                  placeholder={"0..."}
                  fieldOverrides={{
                    fieldStyle: props.focus_view ? NewFieldStyles.greyDarkPrimary : NewFieldStyles.blueDarkSecondary,
                    fieldWidth: props.focus_view ? "100%" : undefined,
                    focus_view: props.focus_view
                  }}
                  valueOverrides={{
                    valueType: "number",
                    defaultValue: tempInput,
                    minValueNumber: 0
                  }}
                  onChange={(e) => setTempInput(e)}
                  onBlur={() => {
                    const numericValue = Number(tempInput);
                    handleFieldChange({ id: numericValue });
                  }}
                />
              </div>
            ) : null}
          </div>
        );
      
      ;
    default:
    return null;
  }
};